import get from 'lodash.get';
import { getRelatedContent } from 'SharedHelpers/getRelatedContent';

/**
 * Extracts content for the ArticleGroup component.
 * @param {Array} related Array of objects that have a type and content key.
 * @param {String} key    What key to look for. Defaults to most popular.
 * @param {Array|boolean} injectedItem  Array of objects that have an injected item, and the position where the item should be placed in the array.
 */
export function getArticleGroupContent({ related, key = 'mostPopular', injectedItem = false }) {
  const relatedContent = getRelatedContent({ related, key }).map(item => ({
    ...item,
    title: item.altTitle || item.title,
  }));

  // Inject the item into the relatedContent array and remove the last one
  if (injectedItem) {
    const position = get(injectedItem, 'position', -1); // By default inject ad at the end.
    relatedContent.splice(position, 1, injectedItem);
  }

  return relatedContent;
}
